import { categories } from "@/mocks/videos";

const navLinks = [
  { label: "首页", href: "#home" },
  { label: "热门精选", href: "#hot" },
  { label: "吃瓜分类", href: "#categories" },
  { label: "全部视频", href: "#videos" },
  { label: "热点专题", href: "#feature" },
  { label: "常见问题", href: "#faq" },
  { label: "关于我们", href: "#about" },
  { label: "联系我们", href: "#contact" },
];

export default function Footer() {
  const cats = categories.filter((c) => c !== "全部");

  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-video-line text-lg"></i>
              </span>
              <span className="font-heading text-xl text-background-50">吃瓜视频</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200/80">
              专注聚合热门吃瓜视频，即点即看、无需安装，高清流畅体验，陪你追更不迷路。
            </p>
            <div className="mt-5 flex gap-3">
              <a href="#home" aria-label="微博" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-100 transition-colors hover:bg-primary-500">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#home" aria-label="抖音" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-100 transition-colors hover:bg-primary-500">
                <i className="ri-music-2-line"></i>
              </a>
              <a href="#home" aria-label="微信" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-100 transition-colors hover:bg-primary-500">
                <i className="ri-wechat-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50">快速导航</h4>
            <ul className="mt-4 grid grid-cols-2 gap-2 text-sm text-background-200/80">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="transition-colors hover:text-accent-300">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50">内容分类</h4>
            <ul className="mt-4 flex flex-col gap-2 text-sm text-background-200/80">
              {cats.map((c) => (
                <li key={c}>
                  <a href="#categories" className="transition-colors hover:text-accent-300">
                    {c}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50">联系方式</h4>
            <ul className="mt-4 flex flex-col gap-3 text-sm text-background-200/80">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                feedback@chigua-video.cn
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line"></i>
                留言建议直达
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line"></i>
                每日实时更新
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-50/10 pt-6 text-xs text-background-200/60 sm:flex-row">
          <p>© 2026 吃瓜视频在线 版权所有 · 仅供个人娱乐参考，请合法合规使用。</p>
          <p>即点即看 · 高清流畅 · 手机适配</p>
        </div>
      </div>
    </footer>
  );
}